import { useQuery } from '@tanstack/react-query';

import { adminFetch } from './useAdminApi';

/**
 * The old Service Fusion jobs still waiting to be deleted after a customer
 * changed an order (1.141).
 *
 * ⚠ Read-only, and there is no mutation to pair with it. A row clears when the
 * job is actually gone — order-lifecycle-check observes the deletion and
 * stamps the old order cancelled — so there is nothing here for a person to
 * mark. See admin-superseded-orders.ts for why a dismiss button would be the
 * wrong shape.
 */

export interface SupersededOrderLink {
  id: string;
  order_number: string | null;
  sf_job_id: string | null;
}

export interface SupersededOrder {
  id: string;
  order_number: string | null;
  sf_job_id: string | null;
  status: string;
  superseded_at: string | null;
  /** False means the dispatch email never went out — different work. */
  dispatch_emailed: boolean;
  replaced_by: SupersededOrderLink | null;
}

export function useSupersededOrders(customerId: string) {
  return useQuery({
    queryKey: ['admin', 'superseded-orders', customerId],
    enabled: !!customerId,
    staleTime: 30_000,
    queryFn: async () => {
      const res = await adminFetch<{ open?: SupersededOrder[]; resolved?: SupersededOrder[] }>(
        `admin-superseded-orders?customer_id=${encodeURIComponent(customerId)}`,
      );
      return { open: res.open ?? [], resolved: res.resolved ?? [] };
    },
  });
}
